import { getSocketInstance } from "./socket.io";

export const onUserOnline = (user) => {
  const socket = getSocketInstance();

  if (!socket) return;

  const entity = user?.viewEntity?.entity?._id;

  const account = user?.viewEntity?.entity?.account?._id;

  socket.emit("USER_ONLINE", {
    account,
    entity,
    _id: user?._id,
    name: user?.name,
  });
};
